import { Grid, Layout } from "antd";
import { GlobalFileUpload } from "~/Components/GlobalFileUpload/GlobalFileUpload";
import { Navigate, useLocation, useOutlet } from "react-router-dom";

import { ErrorBoundary, Header, Navbar } from "@components/index";

import { useEffect, useState } from "react";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { defaultRedirectURL } from "~/Utils/StringConstants";
import styles from "./Layout.module.scss";

const { useBreakpoint } = Grid;
const { Content, Sider } = Layout;
export const ProtectedLayout = () => {
  const [user] = useLocalStorage("user", null);
  const [currentModule] = useLocalStorage("currentModule", null);
  const outlet = useOutlet();
  const location = useLocation();
  const [varCollapsed, setVarCollapsed] = useState(true);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(window.innerHeight - 109);

    window.addEventListener("resize", () => {
      setHeight(window.innerHeight - 109);
    });

    // TODO: We need to  remove on unmount?
  }, []);

  if (!user) {
    return (
      <Navigate
        to="/auth/login"
        replace
        state={{ location }}
      />
    );
  }

  if (!currentModule) {
    //user.role === Roles.SUPER_ADMIN &&
    return (
      <Navigate
        to={defaultRedirectURL("MODULE_SELECTION")}
        replace
        state={{ location }}
      />
    );
  }

  return (
    <Layout style={{ height: "100vh" }}>
      <Header
        onToggleCollapse={setVarCollapsed}
        toggle={varCollapsed}
      />
      <Layout>
        <Sider
          // style={{
          //   height,
          // }}
          className={styles.sidder}
          collapsed={varCollapsed}
        >
          <Navbar collapsed={varCollapsed} />
        </Sider>
        <ErrorBoundary>
          <Content
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              width: "100%",
              height: "100%",
              padding: styles.whitespace2,
            }}
          >
            {outlet}
          </Content>
        </ErrorBoundary>
      </Layout>
      <GlobalFileUpload />
    </Layout>
  );
};
